import store from '@/store'
export function slideTransport(file,desktop=false){
 const source={module:'external',url:file.url,fileName:file.name||file.fileName,fileSize:Number(file.size||file.fileSize)||0}
 async function send(path,data){
  const token=desktop?sessionStorage.getItem('hxt-token'):store.state.token
  const base=desktop?'/api/workbench':(process.env.VUE_APP_API_BASE_URL||'')
  const response=await fetch(base+'/oa/approval/attachments/slides'+path,{method:'POST',headers:{Authorization:'Bearer '+token,'Win-Type':'3','Content-Type':'application/json'},body:JSON.stringify({...source,...data})})
  if(!response.ok)throw new Error('预览服务暂不可用，可重试或下载后打开');return response
 }
 return {
  async status(retry){const result=await (await send('',{retry})).json();if(result.code!==0)throw new Error(result.message||'文档预览不可用');return result.data},
  async page(data){const response=await send('/page',data);if(!(response.headers.get('content-type')||'').startsWith('image/jpeg'))throw new Error('预览页面不可用');const blob=await response.blob();if(blob.size>8*1024*1024)throw new Error('预览页面异常');return URL.createObjectURL(blob)},
  release:src=>URL.revokeObjectURL(src)
 }
}
